import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vShow as _vShow, vModelText as _vModelText, normalizeClass as _normalizeClass, withModifiers as _withModifiers, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 1,
  id: "adultInfoWrapper",
  class: "flex-col view-wrapper"
}
const _hoisted_2 = {
  id: "expCheckin",
  class: "flex-col page-header"
}
const _hoisted_3 = {
  key: 1,
  class: "page-title bold"
}
const _hoisted_4 = { notranslate: "" }
const _hoisted_5 = {
  key: 2,
  class: "page-title bold"
}
const _hoisted_6 = {
  key: 0,
  class: "info-box"
}
const _hoisted_7 = {
  id: "infoForm",
  class: "flex-col"
}
const _hoisted_8 = { class: "form-row" }
const _hoisted_9 = { class: "form-input flex-col" }
const _hoisted_10 = { class: "si-sel-wrapper" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = ["value"]
const _hoisted_13 = {
  key: 0,
  class: "form-input flex-col"
}
const _hoisted_14 = {
  class: "si-input flex-row",
  id: "manualLocation"
}
const _hoisted_15 = ["disabled"]
const _hoisted_16 = {
  key: 1,
  class: "form-row"
}
const _hoisted_17 = { class: "form-input flex-col" }
const _hoisted_18 = {
  key: 0,
  class: "si-sel-wrapper"
}
const _hoisted_19 = ["disabled"]
const _hoisted_20 = ["value", "selected"]
const _hoisted_21 = {
  key: 0,
  class: "loader-sm"
}
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { class: "badge" }
const _hoisted_24 = {
  key: 2,
  id: "emailModal",
  class: "modal"
}
const _hoisted_25 = { class: "modal-content" }
const _hoisted_26 = { class: "flex-row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader_display = _resolveComponent("loader-display")!
  const _component_text_input = _resolveComponent("text-input")!
  const _component_date_input = _resolveComponent("date-input")!
  const _component_custom_field_input = _resolveComponent("custom-field-input")!
  const _component_ski_rental_input = _resolveComponent("ski-rental-input")!
  const _component_checkbox = _resolveComponent("checkbox")!
  const _component_OnClickOutside = _resolveComponent("OnClickOutside")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_loader_display, { key: 0 }))
      : (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (_ctx.showBackBtn)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "back-btn",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1)))
                }))
              : _createCommentVNode("", true),
            (_ctx.partyName)
              ? (_openBlock(), _createElementBlock("h3", _hoisted_3, [
                  _cache[32] || (_cache[32] = _createTextVNode(" Fill out a waiver for ", -1)),
                  _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.partyName), 1),
                  _cache[33] || (_cache[33] = _createTextVNode(" party ", -1))
                ]))
              : (_openBlock(), _createElementBlock("h3", _hoisted_5, "Fill out a waiver")),
            _createElementVNode("span", null, [
              _cache[34] || (_cache[34] = _createTextVNode("We need your information whether you are completing this waiver for yourself or if you are a parent/guardian completing this waiver on behalf of a minor/child.", -1)),
              _cache[35] || (_cache[35] = _createElementVNode("br", null, null, -1)),
              _createTextVNode(_toDisplayString(_ctx.adultAgeMsg), 1)
            ])
          ]),
          (_ctx.isEditing)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _cache[36] || (_cache[36] = _createTextVNode(" This information is tied to your signature and cannot be changed. If you need to update the information below please ", -1)),
                _createElementVNode("button", {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.resetWaiver()))
                }, "fill out a new waiver"),
                _cache[37] || (_cache[37] = _createTextVNode(". You can add minors and activities in the following steps. ", -1))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_7, [
            _cache[46] || (_cache[46] = _createElementVNode("div", { class: "info-header flex-col" }, [
              _createElementVNode("div", { class: "form-title bold" }, "Personal Information")
            ], -1)),
            _createElementVNode("div", {
              class: _normalizeClass(["form-wrapper", { isEditing: _ctx.isEditing }])
            }, [
              _createVNode(_component_text_input, {
                label: 'Email',
                modelValue: _ctx.consenter.email,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.consenter.email) = $event)),
                type: 'email',
                showError: _ctx.errors.email,
                onOnBlur: _cache[3] || (_cache[3] = ($event: any) => (_ctx.validateEmail())),
                errorMsg: 'A valid email is required',
                id: 'email',
                disabled: _ctx.isEditing
              }, null, 8, ["modelValue", "showError", "disabled"]),
              _createVNode(_component_date_input, {
                label: 'Your birthday',
                day: _ctx.consenter.dateOfBirth.day,
                month: _ctx.consenter.dateOfBirth.month,
                year: _ctx.consenter.dateOfBirth.year,
                errorMsg: _ctx.adultAgeMsg,
                onOnDateEntered: _cache[4] || (_cache[4] = ($event: any) => (_ctx.consenter.dateOfBirth = $event)),
                onOnBlur: _cache[5] || (_cache[5] = ($event: any) => (_ctx.validateBirthday())),
                showError: _ctx.errors.dateOfBirth,
                id: 'dateOfBirth',
                disabled: _ctx.isEditing
              }, null, 8, ["day", "month", "year", "errorMsg", "showError", "disabled"]),
              _createVNode(_component_text_input, {
                label: 'First name',
                modelValue: _ctx.consenter.firstName,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.consenter.firstName) = $event)),
                showError: _ctx.errors.firstName,
                onOnBlur: _cache[7] || (_cache[7] = ($event: any) => (_ctx.errors.firstName = $event)),
                id: 'firstName',
                disabled: _ctx.isEditing
              }, null, 8, ["modelValue", "showError", "disabled"]),
              _createVNode(_component_text_input, {
                label: 'Last name',
                modelValue: _ctx.consenter.lastName,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.consenter.lastName) = $event)),
                showError: _ctx.errors.lastName,
                onOnBlur: _cache[9] || (_cache[9] = ($event: any) => (_ctx.errors.lastName = $event)),
                id: 'lastName',
                disabled: _ctx.isEditing
              }, null, 8, ["modelValue", "showError", "disabled"]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _cache[38] || (_cache[38] = _createElementVNode("label", { for: "country" }, "Country", -1)),
                  _createElementVNode("div", _hoisted_10, [
                    _withDirectives(_createElementVNode("select", {
                      class: "si-input",
                      name: "country",
                      id: "countryInput",
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.consenter.countryKey) = $event)),
                      onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.manualLocationEntry = _ctx.consenter.countryKey != 196)),
                      disabled: _ctx.isEditing
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countryOptions, (country, i) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: i,
                          value: country.CountryKey
                        }, _toDisplayString(country.Name), 9, _hoisted_12))
                      }), 128))
                    ], 40, _hoisted_11), [
                      [_vModelSelect, _ctx.consenter.countryKey]
                    ])
                  ]),
                  _cache[39] || (_cache[39] = _createElementVNode("span", { class: "invalid-input-text" }, "This field is required", -1))
                ]),
                _createElementVNode("div", null, [
                  _withDirectives(_createVNode(_component_text_input, {
                    label: 'ZIP / Postal code',
                    modelValue: _ctx.zipCode,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.zipCode) = $event)),
                    showError: _ctx.errors.zipCode,
                    onOnBlur: _cache[13] || (_cache[13] = ($event: any) => (_ctx.validateZip())),
                    id: 'zipCode',
                    disabled: _ctx.isEditing
                  }, null, 8, ["modelValue", "showError", "disabled"]), [
                    [_vShow, _ctx.showZipField]
                  ])
                ])
              ]),
              (!_ctx.manualLocationEntry)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _cache[40] || (_cache[40] = _createElementVNode("label", { for: "cityState" }, "City & State", -1)),
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.formattedLocation), 1),
                      (_ctx.formattedLocation)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.manualLocationEntry = true)),
                            disabled: _ctx.isEditing
                          }, "Enter Manually", 8, _hoisted_15))
                        : _createCommentVNode("", true)
                    ]),
                    _cache[41] || (_cache[41] = _createElementVNode("span", { class: "invalid-input-text" }, "This field is required", -1))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _createVNode(_component_text_input, {
                      label: 'City',
                      modelValue: _ctx.consenter.city,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.consenter.city) = $event))
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("label", null, "State " + _toDisplayString(_ctx.consenter.countryKey == 196 ? '' : '/ Province'), 1),
                      (_ctx.consenter.countryKey == 196)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                            _withDirectives(_createElementVNode("select", {
                              class: "si-input",
                              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.consenter.state) = $event)),
                              notranslate: "",
                              disabled: _ctx.isEditing
                            }, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.states, (state, i) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  key: i,
                                  value: state,
                                  selected: state == _ctx.consenter.state
                                }, _toDisplayString(state), 9, _hoisted_20))
                              }), 128))
                            ], 8, _hoisted_19), [
                              [_vModelSelect, _ctx.consenter.state]
                            ])
                          ]))
                        : _withDirectives((_openBlock(), _createElementBlock("input", {
                            key: 1,
                            type: "text",
                            class: "si-input",
                            name: "state",
                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.consenter.state) = $event))
                          }, null, 512)), [
                            [_vModelText, _ctx.consenter.state]
                          ]),
                      _cache[42] || (_cache[42] = _createElementVNode("span", { class: "invalid-input-text" }, "This field is required", -1))
                    ])
                  ])),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.customFields, (field, i) => {
                return (_openBlock(), _createBlock(_component_custom_field_input, {
                  key: i,
                  customField: field,
                  ref_for: true,
                  ref: `cf${i}`,
                  id: i,
                  disabled: _ctx.isEditing
                }, null, 8, ["customField", "id", "disabled"]))
              }), 128)),
              (_ctx.collectSkiRentalInfo)
                ? (_openBlock(), _createBlock(_component_ski_rental_input, {
                    key: 2,
                    label: 'Experience Level',
                    responses: _ctx.skiRentalFields?.experience ?? [],
                    modelValue: _ctx.consenter.skiExperienceKey,
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.consenter.skiExperienceKey) = $event)),
                    showError: _ctx.errors.skiExp,
                    onOnBlur: _cache[19] || (_cache[19] = ($event: any) => (_ctx.errors.skiExp = $event)),
                    helpText: 'Select your experience level',
                    disabled: _ctx.isEditing
                  }, null, 8, ["responses", "modelValue", "showError", "disabled"]))
                : _createCommentVNode("", true),
              (_ctx.collectSkiRentalInfo)
                ? (_openBlock(), _createBlock(_component_ski_rental_input, {
                    key: 3,
                    label: 'Height',
                    responses: _ctx.skiRentalFields?.heights ?? [],
                    modelValue: _ctx.consenter.skiHeightKey,
                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.consenter.skiHeightKey) = $event)),
                    showError: _ctx.errors.skiHeight,
                    onOnBlur: _cache[21] || (_cache[21] = ($event: any) => (_ctx.errors.skiHeight = $event)),
                    helpText: 'Select your height',
                    disabled: _ctx.isEditing
                  }, null, 8, ["responses", "modelValue", "showError", "disabled"]))
                : _createCommentVNode("", true),
              (_ctx.collectSkiRentalInfo)
                ? (_openBlock(), _createBlock(_component_ski_rental_input, {
                    key: 4,
                    label: 'Weight',
                    responses: _ctx.skiRentalFields?.weights ?? [],
                    modelValue: _ctx.consenter.skiWeightKey,
                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.consenter.skiWeightKey) = $event)),
                    showError: _ctx.errors.skiWeight,
                    onOnBlur: _cache[23] || (_cache[23] = ($event: any) => (_ctx.errors.skiWeight = $event)),
                    helpText: 'Select your weight',
                    disabled: _ctx.isEditing
                  }, null, 8, ["responses", "modelValue", "showError", "disabled"]))
                : _createCommentVNode("", true),
              (_ctx.collectSkiRentalInfo)
                ? (_openBlock(), _createBlock(_component_ski_rental_input, {
                    key: 5,
                    label: 'Shoe size',
                    responses: _ctx.skiRentalFields?.shoes ?? [],
                    modelValue: _ctx.consenter.skiShoeSizeKey,
                    "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.consenter.skiShoeSizeKey) = $event)),
                    showError: _ctx.errors.skiShoes,
                    onOnBlur: _cache[25] || (_cache[25] = ($event: any) => (_ctx.errors.skiShoes = $event)),
                    helpText: 'Select your shoe size',
                    disabled: _ctx.isEditing
                  }, null, 8, ["responses", "modelValue", "showError", "disabled"]))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: "flex-row gap-8 flex-align-start",
                onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.consenter.emailOptIn = _ctx.isEditing ? _ctx.consenter.emailOptIn : !_ctx.consenter.emailOptIn))
              }, [
                _createVNode(_component_checkbox, {
                  checked: _ctx.consenter.emailOptIn
                }, null, 8, ["checked"]),
                _cache[43] || (_cache[43] = _createElementVNode("div", { class: "flex-col gap-8" }, [
                  _createElementVNode("div", { class: "bold" }, "Sign up for our mailing list"),
                  _createElementVNode("div", { class: "text-sm" }, "Stay up to date and receive special promotions, insider access, and upcoming events from us!")
                ], -1))
              ]),
              _cache[44] || (_cache[44] = _createElementVNode("div", null, null, -1))
            ], 2),
            _createElementVNode("button", {
              class: "form-submit-btn",
              onClick: _cache[27] || (_cache[27] = _withModifiers(($event: any) => (_ctx.onNext()), ["stop"]))
            }, [
              (_ctx.emailValidation.isValidating)
                ? (_openBlock(), _createElementBlock("div", _hoisted_21))
                : (_openBlock(), _createElementBlock("span", _hoisted_22, "Next"))
            ]),
            (_ctx.hasCheckins)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "form-btn flex-row gap-6 flex-center",
                  onClick: _cache[28] || (_cache[28] = _withModifiers(($event: any) => (_ctx.editCompleted()), ["stop"]))
                }, [
                  _cache[45] || (_cache[45] = _createElementVNode("div", null, "View Completed Waivers", -1)),
                  _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.checkinCompleteCount) + " of " + _toDisplayString(_ctx.checkinNeededCount), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ])),
    (_ctx.emailValidation.showModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
          _createVNode(_component_OnClickOutside, {
            onTrigger: _cache[31] || (_cache[31] = ($event: any) => (_ctx.tryEmailAgain()))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_25, [
                _cache[47] || (_cache[47] = _createElementVNode("span", null, "Are you sure this is a real email address?", -1)),
                _createElementVNode("span", null, _toDisplayString(_ctx.consenter.email), 1),
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("button", {
                    class: "form-btn",
                    onClick: _cache[29] || (_cache[29] = _withModifiers(($event: any) => (_ctx.tryEmailAgain()), ["stop"]))
                  }, "Try again"),
                  _createElementVNode("button", {
                    class: "form-submit-btn",
                    onClick: _cache[30] || (_cache[30] = _withModifiers(($event: any) => (_ctx.onContinue()), ["stop"]))
                  }, "Yes, it's real")
                ])
              ])
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}